import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-9da54028"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "privacy"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "word-main"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-word"
}, [/*#__PURE__*/_createTextVNode(" 糖果择她平台始终倡导真诚、诚信交友，为积极响应国家扫黄净网行动，创造良好的交友环境。 本平台将严格开展“用户违规行为”整治行动。对发布：反动、诈骗、色情、暴力、贩卖非法物品等违法行为，一经核实将视情节严重情况予以用户警告、限制账号权限、永久封停等处理。维护清朗的社交生态环境。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 如您在使用途中，发现上述违规行为均可联系官方客服处理。 ")], -1));

const _hoisted_5 = {
  class: "list-word"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "name-title"
}, "封禁违规账号名单(展示最近50条)", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "list-back title-list"
}, [/*#__PURE__*/_createElementVNode("span", null, "用户昵称"), /*#__PURE__*/_createElementVNode("span", {
  class: "list-center"
}, "处罚时间"), /*#__PURE__*/_createElementVNode("span", {
  class: "list-right"
}, "处理方式")], -1));

const _hoisted_8 = {
  class: "list-out"
};
const _hoisted_9 = {
  class: "list-center"
};
const _hoisted_10 = {
  class: "list-out list-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.Punish,
    class: "top-img"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass({
        'list-back': true,
        'title-list': true,
        'item-back': index % 2 === 0
      }),
      key: index
    }, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_9, _toDisplayString($setup.toDay(item.createTime)), 1), _createElementVNode("span", _hoisted_10, _toDisplayString($setup.toType(item.type, item.count)), 1)], 2);
  }), 128))])])]);
}